import { render, staticRenderFns } from "./StudentsCard.vue?vue&type=template&id=8925d264&scoped=true"
import script from "./StudentsCard.vue?vue&type=script&lang=js"
export * from "./StudentsCard.vue?vue&type=script&lang=js"
import style0 from "./StudentsCard.vue?vue&type=style&index=0&id=8925d264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8925d264",
  null
  
)

export default component.exports